/*
 *
 * SettingsBankStatementPopup
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 29-Apr-2025
*/

import SettingsBankStatementPopup from './SettingsBankStatementPopupContainer'

export default SettingsBankStatementPopup
